import { BaseModel } from "@models/base.model";
import { PatientPayment } from "./patientpayment.model";

export class ClaimPaymentModel extends BaseModel {
  ClaimId: number;
  EncounterId: number;
  PatientName: string = '';
  PatientId: number;
  PatientNumber: string='';
  AppointmentDate: any;
  BillAmount: number=0;
  Adjustment: number;
  Balance: number = 0;
  ThisPayment: number = 0;
  PatientResponsibility: number = 0;
  ProcedureCode: string = '';
  Modifier: string = '';
  Action: string = '';
  PaymentId: number = 0;
  StatusId: number = 0;
}

export class AdjustmentType extends  BaseModel {
  Name: string = '';
  Description: number;
  DisplayName: string = '';
  EnumName: string = '';
  RowOrder: number;
  DisplayInList: boolean;
  AdjustmentType: Array<any> = [];
}

export class ClaimAdjustment extends BaseModel {
  ClaimId: number;
  AdjustmentTypeId: number;
  PaymentDate: Date;
  Amount: number;
  Notes: string = '';
  DisplayInList: boolean;
  ClaimBalance: number = 0;
  AdjustmentTypeName: string="";
}

export class ClaimTransaction extends BaseModel {
  ClaimId: number;
  TransactionDate: Date;
  Description: string = '';
  BillAmount: number;
  PatientAmount: number;
  Balance: number;
  ClaimAdjustment: Array<any> = [];
  PaymentId: number = 0;
  StatusId: number = 0;
}

export class PaymentMaster {
  AdjustmentType: Array<any> = [];
  PaymentDetail: PatientPayment = new PatientPayment()
}

export class ApplySelfpayModel {
  Entity = new ClaimPaymentModel();
  Masters = new PaymentMaster();
}


export class ManualERA extends BaseModel {
  ClaimId: number;  
  PaymentDate: Date;
  Amount: number;
  CO45: number;
  PR2: number;
  PR3: number;
  Notes: string = '';
  CheckNumber: string = "";
}
